
export default [{
	path: '/customers-cards-types',
	component: () => import('@/components/customers-cards-types/List')
}]
